/* eslint-disable no-unused-vars */
//Application State Handler//

import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

import userSession from "./modules/usersession";
import stateManager from "./modules/statemanager";
import kiosk from "./modules/kiosk";
import knowledgetest from "./modules/knowledgetest";
import settings from "./modules/settings";

const vuePersistSession = new VuexPersistence({
  storage: window.sessionStorage,
  modules: ["userSession"],
});

Vue.use(Vuex);
const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    kiosk,
    userSession,
    stateManager,
    knowledgetest,
    settings,
  },
  plugins: [vuePersistSession.plugin],
});

export default store;
